module.exports = __webpack_public_path__ + "ui-static/img/lines-no-items_dark.834b322c.svg";